import React from 'react';

const GOOGLE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdg7FioPqLfLzklYqdDJk3ztoQKOuAkfxSrOECDSFmpuZDz_A/viewform?usp=header';

const ContactSection = () => {
  return (
    <section
      id="train-with-me"
      data-testid="contact"
      className="py-16 sm:py-20 lg:py-24 bg-black px-6 border-t border-neutral-900"
    >
      <div className="container mx-auto max-w-3xl text-center">
        <p className="text-gray-400 font-bold text-sm tracking-widest uppercase mb-4">
          Get Started
        </p>
        <h2
          data-testid="train-with-me-heading"
          className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-none"
        >
          Train With Me
        </h2>
        <p className="text-gray-300 text-base sm:text-lg mt-6 max-w-xl mx-auto leading-relaxed">
          Take the first step towards complete athlete development. Complete the short application
          form and The Dillon Blueprint will follow up with you soon.
        </p>

        <div className="mt-10">
          <a
            data-testid="apply-for-training"
            href={GOOGLE_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-shine inline-flex items-center justify-center bg-white hover:bg-gray-200 text-black font-bold uppercase tracking-wider text-sm px-10 py-5 rounded-lg transition-colors"
          >
            <span className="relative z-10">Apply For Training</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
